import React, { useState } from "react";
import { TabWrapper } from "../Styled";
import TopProductOrdersTable from "../../Content/TopProductOrdersTable";
import { ContentWrapper } from "../../../../../shared/styled/TableStyles";
import { PieChartComponent } from "../../Content/PieChart";
import { CategoryBarChart } from "./CategoryBarChart";
import TopProductsTable from "../../Content/TopProductTable";
import { PRODUCT_CATEGORY } from "../../../../../data/enums";

export const CategoryTab = () => {
    const [category, setCategory] = useState(PRODUCT_CATEGORY.BARREL);

    return (
        <TabWrapper>
            <CategoryBarChart subType={category} setSubType={setCategory} />

            <div
                style={{
                    display: "flex",
                    width: "100%",
                    gap: "30px",
                }}
            >
                <ContentWrapper>
                    <span
                        style={{
                            fontSize: "22px",
                            fontWeight: 600,
                            fontFamily: "Noto Sans",
                        }}
                    >
                        Tổng quan trạng thái đơn hàng
                    </span>
                    <PieChartComponent />
                </ContentWrapper>

                <TopProductsTable category={category} />
            </div>

            <TopProductOrdersTable />
        </TabWrapper>
    );
};
